import React from 'react';
import AddToWallet from '../../../assets/order/add-to-wallet.svg';
import { walletPassDownloadUrl } from '@/lib/utils';

/**
 * "Add to Apple Wallet" badge for a cashless wallet pass. Gated to iOS the same way the
 * entrance ticket badge is, so it renders nothing on every other device.
 *
 * The badge artwork is Apple's, so it is scaled rather than redrawn — the default is the
 * modal size, and the card strip passes the badge's own 35px height.
 */
const AddToAppleWalletButton: React.FC<{ walletId: string; className?: string }> = ({
    walletId,
    className = 'h-16 py-2 mx-auto',
}) => {
    if (!/(iPhone|iPod|iPad)/i.test(navigator.userAgent)) {
        return null;
    }

    return (
        <a href={walletPassDownloadUrl(walletId)} target="_blank" rel="noopener noreferrer" className='block'>
            <img
                src={AddToWallet}
                alt="Add to Apple Wallet"
                className={`cursor-pointer hover:opacity-80 transition-opacity ${className}`}
            />
        </a>
    );
};

export default AddToAppleWalletButton;
